export const PAGE_SIZES = [
  20,
  50,
  100
]

export const STATUS_LOADING = 'loading'
export const STATUS_LOADED = 'loaded'
export const STATUS_FAILED = 'failed'
export const STATUS_INITIAL = 'initial'

export const DETAIL_MODAL_MAX_FIELD_COUNT = 5

export const FILTER_CATEGORY_CATEGORY = 'category'
export const FILTER_CATEGORY_ACTIVITY = 'activity'
export const FILTER_CATEGORY_BY_WHOM = 'by_whom'
export const FILTER_CATEGORY_DATE_RANGE = 'date_range'

export const PERIOD_TODAY = 'today'
export const PERIOD_THIS_WEEK = 'this_week'
export const PERIOD_THIS_MONTH = 'this_month'

export const AGGREGATION_FILTERS = [FILTER_CATEGORY_CATEGORY, FILTER_CATEGORY_ACTIVITY, FILTER_CATEGORY_BY_WHOM]

const resetFilterKeys = ['filters', 'page_token', 'page']
export const resetFiltersObj = resetFilterKeys.reduce((prev, curr) => ({
  ...prev,
  [curr]: null
}), {})

export const HELP_ARTICLE_URL = 'https://help.calendly.com/hc/en-us/articles/6444529520407'
export const ACTIVITY_LOG_API_DOCS_URL = 'https://calendly.stoplight.io/docs/api-docs/d37c7f031f339-list-activity-log-entries'
export const OUTGOING_COMMS_API_DOCS_URL = 'https://calendly.stoplight.io/docs/api-docs/9f56d7339ee2e-list-outgoing-communications'

export const FEATURE_ACTIVITY_LOG_ACCESS_KEY = 'activity_log_access'
export const SEARCH_TERM_DEBOUNCE_MSEC = 600

export const CONFIRMATION_POPUP_TYPE = 'confirmation'
export const NOT_ALLOWED_POPUP_TYPE = 'not_allowed'
